export default __webpack_public_path__ + "static/media/ecr.0c89c78d.svg";